import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { PureComponent } from "react";
//import { RadialBarChart, RadialBar, Legend, ResponsiveContainer } from 'recharts';
import { useAllAgreementsRepo } from "../../CarrierAgreementMgmt/Agreements/hooks/useAllAgreementsRepo";
import useConfieAgreementCount from "../../CarrierAgreementMgmt/Agreements/hooks/useConfieAgreementsCount";
import useFranchiseAgreementCount from "../../CarrierAgreementMgmt/Agreements/hooks/useFranchiseAgreementsCount";
import useDeactivatedAgreementCount from "../../CarrierAgreementMgmt/Agreements/hooks/useDeactivatedAgreementsCount";
import useAllAgreementCounts from "../../CarrierAgreementMgmt/Agreements/hooks/useGetAllAgreementCount";
import useActiveAgreementCount from "../../CarrierAgreementMgmt/Agreements/hooks/useActiveAgreementCount";
import { franchiseCheckBox } from "../../CarrierAgreementMgmt/OfficeSettings/atoms/atoms";

ChartJS.register(ArcElement, Tooltip, Legend);

const AgreementsChart = () => {
  //Agreements Data
  const { data: agmtData } = useAllAgreementCounts();

  const { data: confieAgreements } = useConfieAgreementCount();
  const { data: franchiseAgreements } = useFranchiseAgreementCount();
  const { data: deactivatedAgreements } = useDeactivatedAgreementCount();
  const { data: activeAgreements } = useActiveAgreementCount();

  //Confie % Computation
  const confieDiv = confieAgreements / agmtData;
  const agmtConfiePercent = confieDiv * 100;
  //Franchise % Computation
  const franDiv = franchiseAgreements / agmtData;
  const agmtFranchiPercent = franDiv * 100;
  //Deactivated % Computation
  const deactDiv = deactivatedAgreements / agmtData;
  const deactPercent = deactDiv * 100;

  const count = confieAgreements + franchiseAgreements;
  const totalCount = count + deactivatedAgreements;

  const agreementsData = {
    datasets: [
      {
        data: [confieAgreements, franchiseAgreements],
        backgroundColor: ["#0078D7", "#EC4899"],
        borderRadius: 5,
        weight: 1.2,
        borderWidth: 5,
      },
      // {
      //   data: [franchiseAgreements, confieAgreements],
      //   backgroundColor: ["#EC4899", "#0078D7"],
      //   borderRadius: 5,
      //   weight: 1.2,
      //   borderWidth: 5,
      // },
      {
        data: [deactivatedAgreements, count],
        backgroundColor: ["#203A75", "#00C8FF"],
        borderRadius: 5,
        weight: 1.2,
        borderWidth: 5,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    pieceLabel: {
      render: "label",
      fontColor: "#000",
      position: "outside",
      segment: true,
    },
    maintainAspectRatio: false,
  };

  return (
    <div>
      <div className="grid grid-cols-2 items-center">
        <div className="grid sm:grid-cols-1">
          <h1 className="text-sm text-tertiary font-semibold">
            Carrier Agreements Status
          </h1>
        </div>
        <div className="grid sm:grid-cols-1">
          <h4 className="text-right text-xs text-tertiary font-base">
            Total of
            <span className="text-base font-semibold"> {totalCount || ""}</span>
          </h4>
        </div>
      </div>
      <div className="flex justify-center">
        <Doughnut
          className="w-full h-full"
          data={agreementsData}
          options={chartOptions}
          // height={180}
          // width={320}
        />
      </div>
      <div className="grid grid-cols-3 mx-8 mt-2">
        <div className="grid sm:grid-cols-1">
          <h1 className="pl-4 text-gray-800 text-xs4 font-bold mr-3">
            {agmtConfiePercent.toFixed(2) + "%"}
          </h1>
          <div className="flex flex-auto">
            <div className="h-2 w-2 rounded-md bg-tabColorDarkBlue m-1"></div>
            <div className="inline-block text-xs4 font-normal">Confie</div>
          </div>
        </div>
        <div className="grid sm:grid-cols-1">
          <h1 className="pl-4 text-gray-800 text-xs4 font-bold">
            {agmtFranchiPercent.toFixed(2) + "%"}
          </h1>
          <div className="flex flex-auto">
            <div className="h-2 w-2 rounded-md bg-hsecondary m-1"></div>
            <div className="inline-block text-xs4 font-normal">Franchise</div>
          </div>
        </div>
        <div className="grid sm:grid-cols-1">
          <h1 className="pl-4 text-gray-800 text-xs4 font-bold mr-1">
            {deactPercent.toFixed(2) + "%"}
          </h1>
          <div className="flex flex-auto">
            <div className="h-2 w-2 rounded-md bg-primary m-1"></div>
            <div className="inline-block text-xs4 font-normal truncate">
              Deactivated
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgreementsChart;
